import { Injectable } from '@angular/core';

import { BaseService } from './base.service';
import { ReviewCalc } from '../model/review-calc.model';

@Injectable()
export class ReviewService {
	constructor(private baseService: BaseService) {}

	path = '/review/';
	filePath = '/file/';
	extPath = '/external/';

	// FOR MODAL AND MODEL

	getAll = (query) => this.baseService.post(this.path, 'getAll/', query);

	getById = (id: number) => this.baseService.get(this.path, '' + id);


	post = (value: ReviewCalc) => this.baseService.post(this.path, '', value);

	put = (value: ReviewCalc) => this.baseService.put(this.path, '', value);

	delete = (id: number) => this.baseService.delete(this.path, '' + id + '/delete');

	// FOR SYNC

	getRecalcDataFromSync = (query) => this.baseService.post('/review-calc/', 'recalc', query);

	getNormalDataFromSync = (query) => this.baseService.post('/review-calc/', 'sync', query);

	// FOR COMPONENT

	getSelectorsFromResponses = () => this.baseService.get('/sync', '/lists');

	getFromResponses = (query) => this.baseService.post('/report', '/checklist-answered-review', query);

	// FOR FILTER RESPONSES

	getFilters = (query) => this.baseService.get(this.path, 'distinct-filtered', query);

	// EXTERNAL ROUTES

	getExternal(externalUrl) {
		return this.baseService.getWithProxy(this.extPath, externalUrl, {});
	}

	getFileExternal(externalUrl) {
		const responseType = { responseType: 'arraybuffer' };
		return this.baseService.getWithProxy(this.filePath, externalUrl, responseType);
	}
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/service/review.service.ts